import { inject, provideAppInitializer } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { LocalStorageService } from '../services/local-storage/local-storage.service';
import { environment } from '../../../environments/environment';
import { AppSettings } from '../interfaces/app-settings.interface';
import { normalizeLang, routeToLang, I18N_CONFIG } from './i18n.config';

export const provideLanguageInitializer = () =>
  provideAppInitializer(async () => {
    const translate = inject(TranslateService);
    const localStorageService = inject(LocalStorageService);
    const document = inject(DOCUMENT);
    const platformId = inject(PLATFORM_ID);

    const pathname = document.defaultView?.location?.pathname?.toLowerCase() ?? '';
    const segment = pathname.split('/').filter(Boolean)[0] ?? '';
    const urlLang = segment ? routeToLang(pathname) : null;

    const lang = urlLang ?? (isPlatformBrowser(platformId)
        ? normalizeLang(localStorageService.getItem<AppSettings>(environment.localStorageKey.appSettings)?.language)
        : I18N_CONFIG.defaultLang);

    translate.setDefaultLang(lang);
    await firstValueFrom(translate.use(lang));
  });
